/**
 * Test IDs for QA automation.
 */
export const testIds = {
  businessEntityLinkOpen: "business-entity-link-open",
} as const;
